export default {
  en: {
    search: "Search",
    obtain: "Obtain",
    contactUs: "Contact Us",
    // Header导航
    nav: {
      home: "Home",
      solutions: "Multi-Cloud Solutions",
      solutionPlan: "Intelligent Computing Services",
      cases: "Cases",
      contact: "Contact Us",
    },
    // 语言选择器
    language: {
      selectLanguage: "Select Language",
      chinese: "Chinese",
      english: "English",
      japanese: "Japanese",
    },
    // Footer
    footer: {
      solutions: "Solutions",
      contactUs: "Contact Us",
      helpDocs: "Help Documents",
      blog: "Blog",
      copyright:
        "Copyright © 2026 Eclick Network Technology Co., Ltd. All rights reserved",
      privacyPolicy: "Privacy Policy",
      backToTop: "Back to Top",
      emailUs: "Or email us at:",
    },
  },
  zh: {
    search: "查询",
    obtain: "获取",
    contactUs: "联系我们",
    // Header导航
    nav: {
      home: "首页",
      solutions: "多云方案",
      solutionPlan: "智算服务",
      cases: "客户案例",
      contact: "联系我们",
    },
    // 语言选择器
    language: {
      selectLanguage: "选择语言 / Select Language",
      chinese: "中文",
      english: "English",
      japanese: "日本語",
    },
    // Footer
    footer: {
      solutions: "解决方案",
      contactUs: "联系我们",
      helpDocs: "帮助文档",
      blog: "博客",
      copyright: "Copyright © 2026 易点天下网络科技股份有限公司 版权所有",
      privacyPolicy: "隐私政策",
      backToTop: "返回顶部",
      emailUs: "Or email us at:",
    },
  },
  ja: {
    search: "問い合わせ",
    obtain: "ゲット",
    contactUs: "お問い合わせ",
    // Header导航
    nav: {
      home: "ホーム",
      solutions: "マルチクラウドソリューション",
      solutionPlan: "インテリジェントコンピューティングサービス",
      cases: "お客様事例",
      contact: "お問い合わせ",
    },
    // 语言选择器
    language: {
      selectLanguage: "言語を選択 / Select Language",
      chinese: "中文",
      english: "English",
      japanese: "日本語",
    },
    // Footer
    footer: {
      solutions: "ソリューション",
      contactUs: "お問い合わせ",
      helpDocs: "ヘルプドキュメント",
      blog: "ブログ",
      copyright: "Copyright © 2026 易点天下网络科技股份有限公司 版権所有",
      privacyPolicy: "プライバシーポリシー",
      backToTop: "トップに戻る",
      emailUs: "Or email us at:",
    },
  },
};
